<template>
    <div class="wrapper noPadding">
        <div class="container-fluid oldInfluencerViewContainer mt-0">
            <div v-if="editMode" key="editModeImage" id="demo" style="max-width: 1200px; max-height: 480px; overflow:hidden" class="row oldInfluencerBannerContainer">
                <img v-bind:src="getImage('edit')" class="oldInfluencerBannerImage" alt=""/>
            </div>
            <div v-else key="noEditModeImage" class="row oldInfluencerBannerContainer">
                <img v-bind:src="getImage('noedit')" class="oldInfluencerBannerImage" alt=""/>
                <a href="" v-on:click.stop.prevent="$bus.$emit('activateProfileBannerEditor')" class="roundPencilContainer"><i class="fa fa-pencil"></i></a>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'profileBanner',
		props: {
            image: String
        },
         data: function() {
        	return {
                currentImage: null,
                editMode: false
        	}
        },
        created: function() {
            var self = this;
            this.currentImage = this.image;
            this.$bus.$on('changedBanner', ($event) => {
                this.currentImage = $event;
            });
            this.$bus.$on('editBanner', ($event) => {
                if ($event && !this.editMode) {
                    this.editMode = true;
                } else if (!$event && this.editMode) {
                    this.editMode = false;
                }
            });
        },
        methods: {
            getImage: function(source) {
                return this.currentImage;
            }
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileBanner.vue?15298c15